








































import { defineComponent, ref } from "@vue/composition-api";
import { Follower } from "@scrile/api-provider/dist/api/FollowingsProvider";
import { Like, LikeSubjectType } from "@scrile/api-provider/dist/api/LikeProvider";
import useAuthUser from "@/hooks/useAuthUser";
import usePager from "@/hooks/usePager";
import providers from "@/lib/api";
import { getProfileUrl } from "@/lib/urlHelpers";
import BaseAvatar from "@/components/BaseAvatar";
import BaseButton from "@/components/BaseButton";
import BaseSpinner from "@/components/BaseSpinner";
import CustomScroll from "@/components/CustomScroll";
import InfiniteScroll from "@/components/InfiniteScroll";
import ModalView from "@/components/ModalView";
import PageTitle from "@/components/PageTitle";

export default defineComponent({
  name: "FeedLikers",
  components: {
    CustomScroll,
    InfiniteScroll,
    ModalView,
    PageTitle,
    BaseAvatar,
    BaseButton,
    BaseSpinner,
  },
  props: {
    postId: { type: String, required: true },
    show: { type: Boolean, default: false },
  },
  setup(props) {
    const { authUser } = useAuthUser();
    const loading = ref(false);
    const processingFollowId = ref("");
    const followings = ref<Follower[]>([]);
    const mappedFollowings = ref<{ [key: string]: boolean }>({});

    const { enableScroll, data, items, getFirstPage, getNextPage } = usePager(page =>
      providers.LikeProvider.likeSearch({
        data: {
          subjects: [{ subjectId: props.postId, subjectType: LikeSubjectType.CONTENT_SET }],
          page,
          size: 10,
          sort: "TIME,DESC",
        },
      })
    );

    const searchFollowings = async (likes: Like[]) => {
      const mappedFollowingUsers: { [key: string]: boolean } = {};
      const followers = await providers.FollowingsProvider.searchFollowings({
        ids: likes.map(i => i.likerId),
      });
      followers.forEach(i => (mappedFollowingUsers[i.userId] = true));
      mappedFollowings.value = { ...mappedFollowings.value, ...mappedFollowingUsers };
    };

    const getData = async () => {
      loading.value = true;
      try {
        await getFirstPage();
        await searchFollowings(items.value);
      } finally {
        loading.value = false;
      }
    };

    const follow = async (userId: string) => {
      if (processingFollowId.value) return;
      try {
        processingFollowId.value = userId;
        await providers.FollowingsProvider.toggle({ id: userId });
        mappedFollowings.value = { ...mappedFollowings.value, [userId]: !mappedFollowings.value[userId] };
      } finally {
        processingFollowId.value = "";
      }
    };

    const getNext = async (cb: () => void) => {
      const prevLikes = items.value;
      await getNextPage(cb);
      const newLikes = items.value.filter(i => !prevLikes.includes(i));
      await searchFollowings(newLikes);
    };

    getData();

    return {
      items,
      data,
      followings,
      enableScroll,
      mappedFollowings,
      authUser,
      processingFollowId,
      loading,
      follow,
      getNext,
      getProfileUrl,
    };
  },
});
